var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluevideooff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9854 8.41048C16.9854 8.41048 17.0182 7.60049 16.9854 7.33618C16.7997 5.59683 15.3465 5 12.4947 5H5.60005C2.14728 5 1 5.89525 1 8.58952V15.7686C1 16.8429 1.41521 17.9257 2.49693 18.6163L3.18529 19",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0098 12.1895V16.0775C17.0098 18.4133 15.9022 19.1895 12.5688 19.1895H7.00977",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0098 7.18945V15.5694C22.0098 17.1123 20.9451 17.6482 19.6524 16.7612L17.0098 14.9596",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0098 5.18945L2.00977 20.1895",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluevideooff);
export default __webpack_public_path__ + "static/media/bluevideooff.f663ad7ba197c7db054382a748f7e0ff.svg";
export { ForwardRef as ReactComponent };